export type { SingleTrailPageProps } from "./single-trail-page";
export { SingleTrailPage } from "./single-trail-page";
